(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atc-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    /* ============================================
       Utilities
       ============================================ */

    var i18nEl = document.querySelector('[data-atc-i18n]');
    if (!i18nEl) return;
    var i18n = JSON.parse(i18nEl.textContent);

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, i18n.money_format);
      }
      var value = (cents / 100);
      var format = i18n.money_format || '{{amount}}';
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, key) {
        switch (key) {
          case 'amount': return value.toFixed(2);
          case 'amount_no_decimals': return Math.round(value).toString();
          case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',');
          case 'amount_no_decimals_with_comma_separator': return Math.round(value).toString();
          case 'amount_with_space_separator': return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          case 'amount_no_decimals_with_space_separator': return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          case 'amount_with_apostrophe_separator': return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
          default: return value.toFixed(2);
        }
      });
    }

    function showToast(heading, variant) {
      var container = document.querySelector('.sds-atc-toast-container');
      if (!container) return;

      var iconSvg = variant === 'ok'
        ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

      var toast = document.createElement('div');
      toast.className = 'sds-toast sds-toast--' + variant + ' sds-atc-toast--entering';
      toast.setAttribute('role', 'alert');
      toast.innerHTML =
        '<div class="sds-toast__content">' +
          '<div class="sds-toast__icon">' + iconSvg + '</div>' +
          '<div class="sds-toast__text">' +
            '<h3 class="sds-toast__heading">' + heading + '</h3>' +
          '</div>' +
        '</div>';

      if (variant === 'ok') {
        toast.innerHTML +=
          '<div class="sds-toast__action">' +
            '<a href="' + i18n.cart_url + '" class="sds-toast__button" style="text-decoration:none;text-align:center;">' + i18n.view_cart + '</a>' +
          '</div>';
      }

      container.appendChild(toast);

      setTimeout(function() {
        toast.classList.remove('sds-atc-toast--entering');
        toast.classList.add('sds-atc-toast--exiting');
        setTimeout(function() { toast.remove(); }, 250);
      }, 3000);
    }

    function updateCartBadge(count) {
      var cartWrap = document.querySelector('.sds-navbar-actions__cart');
      if (!cartWrap) return;

      var badge = cartWrap.querySelector('.sds-navbar-actions__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'sds-navbar-actions__badge';
          cartWrap.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    /* ============================================
       Direct Add to Cart (default-variant products)
       ============================================ */

    function addToCartDirect(variantId, buttonEl) {
      var label = buttonEl.querySelector('.sds-btn__label');
      var originalText = label ? label.textContent : '';
      buttonEl.disabled = true;
      buttonEl.classList.add('sds-btn--disabled');
      if (label) label.textContent = i18n.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || i18n.cart_error); });
        return res.json();
      })
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        updateCartBadge(cart.item_count);
        showToast(i18n.added_to_cart, 'ok');
      })
      .catch(function(err) {
        showToast(err.message || i18n.cart_error, 'warning');
      })
      .finally(function() {
        buttonEl.disabled = false;
        buttonEl.classList.remove('sds-btn--disabled');
        if (label) label.textContent = originalText;
      });
    }

    /* ============================================
       Drawer: Build Content
       ============================================ */

    function buildDrawerContent(data) {
      var contentEl = document.querySelector('.sds-atc-drawer__content');
      if (!contentEl) return;
      contentEl.innerHTML = '';

      var variants = data.variants;
      var options = data.options;
      var firstAvailable = variants.find(function(v) { return v.available; }) || variants[0];

      /* --- Header --- */
      var header = document.createElement('div');
      header.className = 'sds-atc-drawer__header';
      header.innerHTML =
        '<img class="sds-atc-drawer__thumb" src="' + (data.featured_image || '') + '" alt="" loading="lazy">' +
        '<div class="sds-atc-drawer__product-info">' +
          '<p class="sds-atc-drawer__product-name">' + data.name + '</p>' +
          '<p class="sds-atc-drawer__product-price" data-atc-price>' + formatMoney(firstAvailable.price) + '</p>' +
        '</div>';
      contentEl.appendChild(header);

      /* --- Options --- */
      var optionsWrap = document.createElement('div');
      optionsWrap.className = 'sds-atc-drawer__options';

      options.forEach(function(option) {
        var optionDiv = document.createElement('div');
        optionDiv.className = 'sds-pdp__option';

        var label = document.createElement('label');
        label.className = 'sds-pdp__option-label';
        label.textContent = option.name;
        optionDiv.appendChild(label);

        var isColor = option.name === 'Color' || option.name === 'Colour';

        if (isColor) {
          var swatchWrap = document.createElement('div');
          swatchWrap.className = 'sds-pdp__color-swatches';

          option.values.forEach(function(val, vi) {
            var isFirst = vi === 0;
            var swatchLabel = document.createElement('label');
            swatchLabel.className = 'sds-pdp__swatch' + (isFirst ? ' sds-pdp__swatch--active' : '');

            var radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = option.name;
            radio.value = val;
            radio.className = 'sds-pdp__swatch-input';
            radio.dataset.optionPosition = option.position;
            if (isFirst) radio.checked = true;

            var colorSpan = document.createElement('span');
            colorSpan.className = 'sds-pdp__swatch-color';
            colorSpan.style.backgroundColor = (data.color_map && data.color_map[val]) || val.toLowerCase();

            swatchLabel.appendChild(radio);
            swatchLabel.appendChild(colorSpan);
            swatchWrap.appendChild(swatchLabel);
          });

          optionDiv.appendChild(swatchWrap);
        } else {
          var selectWrap = document.createElement('div');
          selectWrap.className = 'sds-pdp__select-wrap';

          var select = document.createElement('select');
          select.name = option.name;
          select.className = 'sds-pdp__select';
          select.dataset.optionPosition = option.position;

          option.values.forEach(function(val) {
            var opt = document.createElement('option');
            opt.value = val;
            opt.textContent = val;
            select.appendChild(opt);
          });

          var chevron = document.createElement('i');
          chevron.className = 'fa-solid fa-chevron-down sds-pdp__select-icon';

          selectWrap.appendChild(select);
          selectWrap.appendChild(chevron);
          optionDiv.appendChild(selectWrap);
        }

        optionsWrap.appendChild(optionDiv);
      });

      contentEl.appendChild(optionsWrap);

      /* --- Hidden variant ID --- */
      var hiddenId = document.createElement('input');
      hiddenId.type = 'hidden';
      hiddenId.dataset.atcVariantId = '';
      hiddenId.value = firstAvailable.id;
      contentEl.appendChild(hiddenId);

      /* --- Footer: quantity + ATC button --- */
      var footer = document.createElement('div');
      footer.className = 'sds-atc-drawer__footer';

      var qtyRow = document.createElement('div');
      qtyRow.className = 'sds-atc-drawer__qty-row';
      qtyRow.innerHTML =
        '<span class="sds-atc-drawer__qty-label">' + i18n.quantity + '</span>' +
        '<div class="sds-qty">' +
          '<button type="button" class="sds-qty__btn" data-atc-qty-minus><i class="fa-solid fa-minus"></i></button>' +
          '<input type="number" class="sds-qty__input" value="1" min="1" data-atc-qty-input>' +
          '<button type="button" class="sds-qty__btn" data-atc-qty-plus><i class="fa-solid fa-plus"></i></button>' +
        '</div>';
      footer.appendChild(qtyRow);

      var submitBtn = document.createElement('button');
      submitBtn.type = 'button';
      submitBtn.className = 'sds-btn sds-btn--primary sds-btn--medium sds-atc-drawer__submit';
      submitBtn.innerHTML =
        '<span class="sds-btn__label">' + i18n.add_to_cart + '</span>' +
        '<span class="sds-btn__icon"><i class="fa-solid fa-cart-shopping"></i></span>';
      submitBtn.dataset.atcSubmit = '';
      if (!firstAvailable.available) {
        submitBtn.disabled = true;
        submitBtn.classList.add('sds-btn--disabled');
        submitBtn.querySelector('.sds-btn__label').textContent = i18n.sold_out;
      }
      footer.appendChild(submitBtn);

      contentEl.appendChild(footer);

      /* --- Wire up events --- */
      var optionInputs = contentEl.querySelectorAll('[data-option-position]');

      /* Swatch clicks */
      contentEl.querySelectorAll('.sds-pdp__swatch-input').forEach(function(radio) {
        radio.addEventListener('change', function() {
          var parent = this.closest('.sds-pdp__color-swatches');
          if (parent) {
            parent.querySelectorAll('.sds-pdp__swatch').forEach(function(s) {
              s.classList.remove('sds-pdp__swatch--active');
            });
            this.closest('.sds-pdp__swatch').classList.add('sds-pdp__swatch--active');
          }
          onDrawerVariantChange(variants, optionInputs, contentEl);
        });
      });

      /* Select changes */
      contentEl.querySelectorAll('.sds-pdp__select').forEach(function(sel) {
        sel.addEventListener('change', function() {
          onDrawerVariantChange(variants, optionInputs, contentEl);
        });
      });

      /* Quantity +/- */
      var qtyInput = contentEl.querySelector('[data-atc-qty-input]');
      contentEl.querySelector('[data-atc-qty-minus]').addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      contentEl.querySelector('[data-atc-qty-plus]').addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });

      /* Submit */
      contentEl.querySelector('[data-atc-submit]').addEventListener('click', function() {
        submitDrawerATC(contentEl);
      });
    }

    /* ============================================
       Drawer: Variant Change Handler
       ============================================ */

    function onDrawerVariantChange(variants, optionInputs, contentEl) {
      var selectedOptions = {};
      optionInputs.forEach(function(inp) {
        if (inp.type === 'radio' && !inp.checked) return;
        selectedOptions['option' + inp.dataset.optionPosition] = inp.value;
      });

      var matched = variants.find(function(v) {
        var match = true;
        Object.keys(selectedOptions).forEach(function(key) {
          if (v[key] !== selectedOptions[key]) match = false;
        });
        return match;
      });

      var priceEl = contentEl.querySelector('[data-atc-price]');
      var variantInput = contentEl.querySelector('[data-atc-variant-id]');
      var submitBtn = contentEl.querySelector('[data-atc-submit]');
      var label = submitBtn ? submitBtn.querySelector('.sds-btn__label') : null;

      if (matched) {
        if (variantInput) variantInput.value = matched.id;
        if (priceEl) priceEl.textContent = formatMoney(matched.price);

        if (submitBtn && label) {
          if (matched.available) {
            submitBtn.disabled = false;
            submitBtn.classList.remove('sds-btn--disabled');
            label.textContent = i18n.add_to_cart;
          } else {
            submitBtn.disabled = true;
            submitBtn.classList.add('sds-btn--disabled');
            label.textContent = i18n.sold_out;
          }
        }
      }
    }

    /* ============================================
       Drawer: Submit ATC
       ============================================ */

    function submitDrawerATC(contentEl) {
      var variantId = contentEl.querySelector('[data-atc-variant-id]');
      var qtyInput = contentEl.querySelector('[data-atc-qty-input]');
      var submitBtn = contentEl.querySelector('[data-atc-submit]');
      var label = submitBtn ? submitBtn.querySelector('.sds-btn__label') : null;

      if (!variantId || !variantId.value) return;

      var originalText = label ? label.textContent : '';
      submitBtn.disabled = true;
      submitBtn.classList.add('sds-atc--loading');
      if (label) label.textContent = i18n.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId.value),
          quantity: parseInt(qtyInput.value) || 1
        })
      })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(d) { throw new Error(d.description || i18n.cart_error); });
        return res.json();
      })
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        updateCartBadge(cart.item_count);
        var dialog = document.getElementById('sds-atc-drawer');
        if (dialog) dialog.close();
        showToast(i18n.added_to_cart, 'ok');
      })
      .catch(function(err) {
        showToast(err.message || i18n.cart_error, 'warning');
      })
      .finally(function() {
        submitBtn.disabled = false;
        submitBtn.classList.remove('sds-atc--loading');
        if (label) label.textContent = originalText;
      });
    }

    /* ============================================
       Open Drawer
       ============================================ */

    function openATCDrawer(cardEl) {
      var jsonEl = cardEl.querySelector('[data-pcard-variants]');
      if (!jsonEl) return;

      var data = JSON.parse(jsonEl.textContent);
      var nameEl = cardEl.querySelector('.sds-pcard__name');
      var imgEl = cardEl.querySelector('.sds-pcard__img');

      data.name = nameEl ? nameEl.textContent.trim() : '';
      data.featured_image = data.featured_image || (imgEl ? imgEl.src : '');

      buildDrawerContent(data);

      var dialog = document.getElementById('sds-atc-drawer');
      if (dialog) dialog.showModal();
    }

    /* ============================================
       Init: Event Delegation
       ============================================ */

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.sds-pcard__cart-btn');
      if (!btn) return;

      e.preventDefault();
      var card = btn.closest('.sds-pcard');
      if (!card) return;

      var isDefault = card.dataset.hasOnlyDefaultVariant === 'true';

      if (isDefault) {
        var variantId = card.dataset.variantId;
        if (variantId) addToCartDirect(variantId, btn);
      } else {
        openATCDrawer(card);
      }
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sds-carousel').forEach(function(carousel) {
    if (carousel.dataset.carouselInitialized === 'true') return;
    carousel.dataset.carouselInitialized = 'true';

    var track = carousel.querySelector('.sds-carousel__track');
    if (!track) return;

    var dotsContainer = carousel.querySelector('.sds-carousel__dots');
    var slides = Array.from(track.children);
    var isGallery = carousel.classList.contains('sds-carousel--gallery');
    var visible = parseInt(getComputedStyle(carousel).getPropertyValue('--sds-carousel-visible')) || 1;
    var isPointerDown = false;
    var isDragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var activePointerId = null;
    var suppressClick = false;
    var dragThreshold = 4;

    // Gallery mode: each slide is 1 item
    var itemsPerPage = isGallery ? 1 : visible;
    var totalDots = Math.ceil(slides.length / itemsPerPage);

    // Build dots
    if (dotsContainer && totalDots > 1) {
      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'sds-carousel__dot' + (i === 0 ? ' sds-carousel__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = i;
        dotsContainer.appendChild(dot);
      }
    }

    var dots = dotsContainer ? Array.from(dotsContainer.children) : [];

    function getSlideWidth() {
      if (!slides.length) return 0;
      return slides[0].offsetWidth + parseFloat(getComputedStyle(track).gap || 0);
    }

    // Arrow nav (gallery)
    var prevBtn = carousel.querySelector('.sds-carousel__arrow--prev');
    var nextBtn = carousel.querySelector('.sds-carousel__arrow--next');

    function getCurrentSlideIndex() {
      var slideWidth = getSlideWidth();
      if (slideWidth === 0) return 0;
      return Math.round(track.scrollLeft / slideWidth);
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var idx = getCurrentSlideIndex();
      prevBtn.hidden = idx <= 0;
      nextBtn.hidden = idx >= slides.length - 1;
    }

    function updateDots() {
      if (!dots.length) return;
      var slideWidth = getSlideWidth();
      if (slideWidth === 0) return;
      var activeIndex = Math.round(track.scrollLeft / (slideWidth * itemsPerPage));
      activeIndex = Math.min(activeIndex, dots.length - 1);
      dots.forEach(function(d, i) {
        d.classList.toggle('sds-carousel__dot--active', i === activeIndex);
      });
    }

    function updateControls() {
      updateDots();
      updateArrows();
    }

    function animateScroll(index, duration) {
      var slideWidth = getSlideWidth();
      var targetScroll = index * slideWidth * itemsPerPage;
      var start = track.scrollLeft;
      var distance = targetScroll - start;
      if (distance === 0) return;
      var startTime = null;

      track.classList.add('sds-carousel__track--dragging');

      function ease(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function step(time) {
        if (!startTime) startTime = time;
        var elapsed = time - startTime;
        var progress = Math.min(elapsed / duration, 1);

        track.scrollLeft = start + distance * ease(progress);

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          track.classList.remove('sds-carousel__track--dragging');
          updateControls();
        }
      }

      requestAnimationFrame(step);
    }

    // Dot clicks: ease-out animate
    if (dotsContainer) {
      dotsContainer.addEventListener('click', function(e) {
        var dot = e.target.closest('.sds-carousel__dot');
        if (dot) animateScroll(parseInt(dot.dataset.index), 400);
      });
    }

    // Arrow clicks: faster animation
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var idx = getCurrentSlideIndex();
        if (idx > 0) animateScroll(idx - 1, 250);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var idx = getCurrentSlideIndex();
        if (idx < slides.length - 1) animateScroll(idx + 1, 250);
      });
    }

    // Initial arrow state
    updateArrows();

    var lastX = 0;
    var velocity = 0;
    var lastTime = 0;

    function smoothSnapToSlide() {
      var slideWidth = getSlideWidth();
      if (slideWidth === 0) return;
      var targetIndex = Math.round(track.scrollLeft / slideWidth);
      animateScroll(targetIndex, 300);
    }

    function endDrag(e) {
      if (!isPointerDown) return;
      if (e && activePointerId !== null && e.pointerId !== activePointerId) return;

      var pointerId = activePointerId;
      var wasDragging = isDragging;

      isPointerDown = false;
      isDragging = false;
      activePointerId = null;
      /* smoothSnapToSlide manages the dragging class removal */

      if (pointerId !== null && track.hasPointerCapture(pointerId)) {
        track.releasePointerCapture(pointerId);
      }

      if (wasDragging) {
        suppressClick = true;
        window.setTimeout(function() {
          suppressClick = false;
        }, 100);
        smoothSnapToSlide();
      } else {
        track.classList.remove('sds-carousel__track--dragging');
      }
    }

    track.addEventListener('pointerdown', function(e) {
      if (e.button !== 0) return;
      if (e.pointerType === 'touch') return;
      if (track.scrollWidth <= track.clientWidth) return;

      isPointerDown = true;
      isDragging = false;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      track.setPointerCapture(activePointerId);
    });

    track.addEventListener('pointermove', function(e) {
      if (!isPointerDown) return;
      if (e.pointerId !== activePointerId) return;
      if (e.pointerType === 'touch') return;

      var deltaX = e.clientX - startX;
      if (!isDragging && Math.abs(deltaX) < dragThreshold) return;

      isDragging = true;
      track.classList.add('sds-carousel__track--dragging');
      e.preventDefault();
      track.scrollLeft = startScrollLeft - deltaX;
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);
    track.addEventListener('dragstart', function(e) {
      e.preventDefault();
    });

    track.addEventListener('click', function(e) {
      if (!suppressClick) return;

      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }, true);

    // Update controls on scroll
    track.addEventListener('scroll', updateControls, { passive: true });
    updateControls();

    // Gallery fullscreen lightbox
    if (isGallery && slides.length > 0) {
      // Add fullscreen trigger button on top of gallery
      var fsBtn = document.createElement('button');
      fsBtn.className = 'sds-carousel__fullscreen-btn';
      fsBtn.setAttribute('aria-label', 'View fullscreen');
      fsBtn.innerHTML = '<i class="fa-solid fa-expand"></i>';
      carousel.appendChild(fsBtn);

      // Collect all image srcs
      var imageSrcs = [];
      slides.forEach(function(s) {
        var img = s.querySelector('img');
        if (img) imageSrcs.push({ src: img.src, alt: img.alt || '' });
      });

      // Build lightbox
      var lb = document.createElement('div');
      lb.className = 'sds-carousel-lightbox';
      var lbHtml = '<button class="sds-carousel-lightbox__close" aria-label="Close"><i class="fa-solid fa-xmark"></i></button>';
      lbHtml += '<button class="sds-carousel-lightbox__nav sds-carousel-lightbox__nav--prev" aria-label="Previous"><i class="fa-solid fa-chevron-left"></i></button>';
      lbHtml += '<img class="sds-carousel-lightbox__img" src="" alt="">';
      lbHtml += '<button class="sds-carousel-lightbox__nav sds-carousel-lightbox__nav--next" aria-label="Next"><i class="fa-solid fa-chevron-right"></i></button>';
      lbHtml += '<div class="sds-carousel-lightbox__counter"></div>';
      lb.innerHTML = lbHtml;
      document.body.appendChild(lb);

      var lbImg = lb.querySelector('.sds-carousel-lightbox__img');
      var lbClose = lb.querySelector('.sds-carousel-lightbox__close');
      var lbPrev = lb.querySelector('.sds-carousel-lightbox__nav--prev');
      var lbNext = lb.querySelector('.sds-carousel-lightbox__nav--next');
      var lbCounter = lb.querySelector('.sds-carousel-lightbox__counter');
      var lbIndex = 0;

      function lbShow(idx) {
        lbIndex = idx;
        lbImg.src = imageSrcs[idx].src;
        lbImg.alt = imageSrcs[idx].alt;
        lbCounter.textContent = (idx + 1) + ' / ' + imageSrcs.length;
        lbPrev.style.visibility = idx <= 0 ? 'hidden' : 'visible';
        lbNext.style.visibility = idx >= imageSrcs.length - 1 ? 'hidden' : 'visible';
      }

      function lbOpen(idx) {
        lbShow(idx || 0);
        lb.classList.add('sds-carousel-lightbox--open');
        document.body.style.overflow = 'hidden';
      }

      function lbCloseHandler() {
        lb.classList.remove('sds-carousel-lightbox--open');
        document.body.style.overflow = '';
      }

      fsBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        lbOpen(getCurrentSlideIndex());
      });

      lbClose.addEventListener('click', function(e) { e.stopPropagation(); lbCloseHandler(); });
      lbPrev.addEventListener('click', function(e) { e.stopPropagation(); if (lbIndex > 0) lbShow(lbIndex - 1); });
      lbNext.addEventListener('click', function(e) { e.stopPropagation(); if (lbIndex < imageSrcs.length - 1) lbShow(lbIndex + 1); });
      lb.addEventListener('click', lbCloseHandler);
      lbImg.addEventListener('click', function(e) { e.stopPropagation(); });

      document.addEventListener('keydown', function(e) {
        if (!lb.classList.contains('sds-carousel-lightbox--open')) return;
        if (e.key === 'Escape') lbCloseHandler();
        if (e.key === 'ArrowLeft' && lbIndex > 0) lbShow(lbIndex - 1);
        if (e.key === 'ArrowRight' && lbIndex < imageSrcs.length - 1) lbShow(lbIndex + 1);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog"] && !Shopify.designMode) return;
  try {
    // Open dialog: document.getElementById('dialog-id').showModal()
  // Close dialog: document.getElementById('dialog-id').close()
  // Close on backdrop click
  document.querySelectorAll('.sds-dialog').forEach(function(dialog) {
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) {
        dialog.close();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sds-qty').forEach(function(qty) {
    var input = qty.querySelector('[data-sds-qty-input]');
    var minus = qty.querySelector('[data-sds-qty-minus]');
    var plus = qty.querySelector('[data-sds-qty-plus]');
    var min = parseInt(input.min) || 1;

    minus.addEventListener('click', function() {
      var val = parseInt(input.value) || min;
      if (val > min) {
        input.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    plus.addEventListener('click', function() {
      var val = parseInt(input.value) || min;
      input.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-popover"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sds-share').forEach(function(wrapper) {
    if (wrapper.dataset.shareInit === 'true') return;
    wrapper.dataset.shareInit = 'true';

    var trigger = wrapper.querySelector('.sds-share__trigger');
    var popover = wrapper.querySelector('.sds-share__popover');
    if (!trigger || !popover) return;

    var shareUrl = wrapper.dataset.url || window.location.href;
    var shareTitle = wrapper.dataset.title || document.title;

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (navigator.share) {
        navigator.share({ title: shareTitle, url: shareUrl }).catch(function() {});
        return;
      }
      popover.classList.toggle('sds-share__popover--open');
    });

    popover.addEventListener('click', function(e) {
      var option = e.target.closest('[data-action]');
      if (!option) return;
      var action = option.dataset.action;
      var url = shareUrl;
      var title = shareTitle;

      if (action === 'copy') {
        navigator.clipboard.writeText(url).then(function() {
          var icon = option.querySelector('i');
          var label = option.querySelector('span');
          icon.className = 'fa-solid fa-check';
          icon.style.color = 'var(--sds-text-brand-default)';
          label.textContent = 'Copied!';
          setTimeout(function() {
            icon.className = 'fa-regular fa-copy';
            icon.style.color = '';
            label.textContent = 'Copy link';
            popover.classList.remove('sds-share__popover--open');
          }, 1200);
        });
        return;
      } else if (action === 'whatsapp') {
        window.open('https://wa.me/?text=' + encodeURIComponent(title + ' ' + url), '_blank');
      } else if (action === 'x') {
        window.open('https://x.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title), '_blank');
      } else if (action === 'email') {
        window.location.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
      }

      popover.classList.remove('sds-share__popover--open');
    });

    document.addEventListener('click', function() {
      popover.classList.remove('sds-share__popover--open');
    });

    popover.addEventListener('click', function(e) { e.stopPropagation(); });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sds-tabs').forEach(function(tabBar) {
    tabBar.addEventListener('click', function(e) {
      var tab = e.target.closest('.sds-tabs__tab');
      if (!tab) return;
      tabBar.querySelectorAll('.sds-tabs__tab').forEach(function(t) {
        t.classList.remove('sds-tabs__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('sds-tabs__tab--active');
      tab.setAttribute('aria-selected', 'true');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tag-toggle"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sds-tag-toggle').forEach(function(toggle) {
    toggle.querySelector('.sds-tag-toggle__input').addEventListener('change', function() {
      toggle.classList.toggle('sds-tag-toggle--active', this.checked);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
